import api from "../../api";

export const getAllUsers = async (token, page = 1, limit = 20) => {
  try {
    const res = await api.get("admin/users", {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};
